import {
  refreshTokens
} from "./chunk-HHLL3SNP.mjs";

// src/hooks/wbk/auth/refreshTokens.ts
import { useMutation } from "@tanstack/react-query";
var useRefreshTokens = () => {
  return useMutation({
    mutationFn: refreshTokens
  });
};

export {
  useRefreshTokens
};
//# sourceMappingURL=chunk-HSAIIPMN.mjs.map